import axios from "axios";
import { API_URL } from "../config";
import authService from "./auth";

const protocoloService = {
  criar: async (formData) => {
    const response = await axios.post(`${API_URL}Protocolo`, formData, {
      headers: {
        ...authService.getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  obterPorId: async (id) => {
    const response = await axios.get(`${API_URL}Protocolo/${id}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data?.data ?? response.data;
  },

  listarMinhas: async (pageNumber = 1, pageSize = 10) => {
    const params = new URLSearchParams({ pageNumber, pageSize });
    const response = await axios.get(`${API_URL}Protocolo/Usuario/Minhas?${params.toString()}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },

  listarTodasAnalista: async (pageNumber = 1, pageSize = 5) => {
    const params = new URLSearchParams({ pageNumber, pageSize });
    const response = await axios.get(`${API_URL}Protocolo/Analista/Todas?${params.toString()}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },

  atualizarAnalista: async (id, status, observacoes) => {
    const response = await axios.put(
      `${API_URL}Protocolo/Analista/Status`,
      { id, status, observacoes },
      { headers: authService.getAuthHeader() },
    );
    return response.data;
  },

  emitir: async (id, observacoes) => {
    const response = await axios.put(
      `${API_URL}Protocolo/Analista/Emitir`,
      { id, observacoes },
      { headers: authService.getAuthHeader() },
    );
    return response.data;
  },

  listarTodasSecretario: async (pageNumber = 1, pageSize = 5) => {
    const params = new URLSearchParams({ pageNumber, pageSize });
    const response = await axios.get(`${API_URL}Protocolo/Secretario/Todas?${params.toString()}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },

  aprovarSecretario: async (id) => {
    const response = await axios.put(
      `${API_URL}Protocolo/Secretario/Aprovar`,
      { id },
      { headers: authService.getAuthHeader() },
    );
    return response.data;
  },
};

export default protocoloService;
